<script setup lang="ts">
defineProps<{
  title: string
  body: string
}>()
</script>

<template>
  <div class="flex w-full flex-col rounded-lg bg-white p-4 bordershadow-gray">
    <Heading as="h3" size="small" class="text-xs uppercase !text-gray-500">{{ title }}</Heading>
    <Paragraph size="normal" weight="medium">
      {{ body }}
    </Paragraph>
  </div>
</template>
